import { Routes } from '@angular/router';
import { AppInitializerErrorGuard, AppInitializerNoErrorGuard } from '@shared/core';

export const routes: Routes = [
    {
        path: '',
        redirectTo: '/main',
        pathMatch: 'full',
    },
    {
        path: '',
        canActivate: [AppInitializerErrorGuard],
        loadChildren: () => import('@shared/public-feature').then(m => m.routes),
    },
    {
        path: 'main',
        canActivate: [AppInitializerErrorGuard],
        loadChildren: () => import('@mca-feature').then(m => m.routes),
    },
    {
        path: 'error',
        canActivate: [AppInitializerNoErrorGuard],
        loadChildren: () => import('@shared/error-feature').then(m => m.routes),
    },
    { path: '**', redirectTo: '/' },
];
